/* eslint-disable react/no-array-index-key */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../../hooks/useCurrency';
import OrderProduct from '../orderProduct';
import ConfirmButton from '../../../../components/buttons/confirmButton';
import { useSplitItems } from '../../hooks/useSplitItems';

const SplitBillItems = ({ order, onConfirm }) => {
  const { currencySymbol } = useCurrency();
  const { t } = useTranslation();

  const { totalBill, formedProducts, selected, setSelected } = useSplitItems(order);

  return (
    <div>
      {(formedProducts || []).map((product, ind) => {
        const productSelection = selected.find((x) => x.id === product.id && x.index === ind);

        return (
          <OrderProduct
            key={`${product.id}-${ind}`}
            product={product}
            selectable
            selected={productSelection && productSelection.selected}
            onSelect={(val) => {
              const newVal = [...selected];
              const currentSelection = selected.find((x) => x.id === product.id && x.index === ind);

              if (currentSelection) {
                currentSelection.selected = val;
              } else {
                newVal.push({ id: product.id, index: ind, selected: val, total: product.total });
              }

              setSelected(newVal);
            }}
            paid={product.isPaid}
          />
        );
      })}
      <div className="mt-10" />
      <div className="flex flex-row justify-between items-center">
        <p className="font-primaryMedium text-base text-bland">{t('checkout.totalBill')}</p>
        <p className="font-primaryMedium text-base text-bland">
          {totalBill.toFixed(2)} {currencySymbol}
        </p>
      </div>
      <ConfirmButton
        onClick={() => {
          const paidForItems = {};

          selected.forEach((item) => {
            if (paidForItems[item.id]) {
              paidForItems[item.id].quantity += 1;
            } else {
              paidForItems[item.id] = { quantity: 1 };
            }
          });

          onConfirm(
            totalBill,
            Object.entries(paidForItems).map(([id, val]) => ({
              product: id,
              quantity: val.quantity,
            })),
          );
        }}
        disabled={!totalBill}
      />
    </div>
  );
};

export default SplitBillItems;
